import {
  findMultipleFacets,
  findSingleFacet,
  bundleFacetIds,
} from 'ui-shared/Facets'
import { parseFacet } from '../facets'
import { optionedProductParse, optionedProductWrite } from '../optionedProduct'
import { upsellingParse } from '../upselling'
import { ExperienceToAPI } from './types/api/request-models'
import { APIExperience } from './types/api/response-models'
import { Experience } from './types/internal/experience-models'

// ============
// PARSE
// ============

export const experienceParse = (res: APIExperience): Experience => {
  // objects full of all Experiences item information. Used inside event edit and create

  const upsellingItemsFull = (res.upselling ?? []).map(upsellingParse)
  const facets = res.facets.map(parseFacet)
  const tagFacets = findMultipleFacets(facets, 'tag')
  const skillFacet = findSingleFacet(facets, 'productFilter', 'Skill')
  const maxQuantity = Math.max(...res.pricing.map((e) => e.maxQuantity))

  return {
    ...res,
    ...optionedProductParse(res),
    upsellingItemsFull,
    tagFacets,
    maxQuantity,
    skillFacet,
  }
}

// ============
// WRITE
// ============

export const experienceWrite = async ({
  tagFacets = [],
  skillFacet,
  ...rest
}: Experience): Promise<ExperienceToAPI> => {
  const facets = bundleFacetIds(...tagFacets, skillFacet)

  return {
    ...(await optionedProductWrite(rest)),
    facets,
  }
}
